import { __assign, __rest } from "tslib";
import React from "react";
import VeltCommentDialogAssigneeBannerResolveButton from "./VeltCommentDialogAssigneeBannerResolveButton/VeltCommentDialogAssigneeBannerResolveButton";
import VeltCommentDialogAssigneeBannerUserAvatar from "./VeltCommentDialogAssigneeBannerUserAvatar/VeltCommentDialogAssigneeBannerUserAvatar";
import VeltCommentDialogAssigneeBannerUserName from "./VeltCommentDialogAssigneeBannerUserName/VeltCommentDialogAssigneeBannerUserName";
import VeltCommentDialogAssigneeBannerUnresolveButton from "./VeltCommentDialogAssigneeBannerUnresolveButton/VeltCommentDialogAssigneeBannerUnresolveButton";
import { transformWireframeProps } from "../../../utils/propUtils";
;
var VeltCommentDialogAssigneeBanner = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-assignee-banner-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogAssigneeBanner.ResolveButton = VeltCommentDialogAssigneeBannerResolveButton;
VeltCommentDialogAssigneeBanner.UserAvatar = VeltCommentDialogAssigneeBannerUserAvatar;
VeltCommentDialogAssigneeBanner.UserName = VeltCommentDialogAssigneeBannerUserName;
VeltCommentDialogAssigneeBanner.UnresolveButton = VeltCommentDialogAssigneeBannerUnresolveButton;
export default VeltCommentDialogAssigneeBanner;
